import clsx from 'clsx';
import { HTMLAttributes, ReactNode } from 'react';

export type AppbarProps = {
  children?: ReactNode;
} & HTMLAttributes<HTMLElement>;

/**
 * @component Appbar
 */
function Appbar({ children, className, ...rest }: AppbarProps) {
  const classes = clsx(
    `sticky top-0 flex items-center px-6 md:px-8 w-full h-[112px] min-h-[112px] lg:h-[140px] lg:min-h-[140px]`,
    className,
  );
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export default Appbar;
